<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} ELD
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- Serial No -->
        <vs-input
          label="Serial No *"
          v-model="serial"
          class="w-full mt-4"
          type="num"
          name="serial"
          v-validate="'required|max:12'"
        />
        <span class="text-danger">{{ errors.first("serial") }}</span>
        <!-- Notes -->
        <vs-input label="Notes" v-model="Notes" class="mt-5 w-full" />
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData">Submit</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
  <!-- :disabled="!isFormValid" -->
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      Notes: "",
      serial: "",
      id: null,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        const { serial_number, notes_eld, id } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.serial = serial_number;
        this.Notes = notes_eld;
        this.id = id;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    initValues() {
      if (this.data.id) return;
      // eslint-disable-next-line no-unused-expressions
      (this.id = ""), (this.serial = ""), (this.Notes = "");
    },
    submitData() {
      // this.$vs.loading()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const obj = {
            id: this.id,
            serial_number: this.serial,
            notes_eld: this.Notes,
            status: true,
          };
          if (Object.entries(this.data).length === 0) {
            delete obj.id;
            this.$store
              .dispatch("eld/addItem", obj)
              .then((response) => {
                // console.log(response);
                // this.$vs.loading.close()
                this.$vs.notify({
                  title: "Ok",
                  text: "Eld created",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch(() => {
                // this.$vs.loading.close()
                this.$vs.notify({
                  title: "Error",
                  text: "Eld already exist",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          } else {
            // delete obj.id
            // obj.popularity = 0
            this.$store
              .dispatch("eld/updateItem", obj)
              .then((response) => {
                // console.log(response, "korici");
                // this.$vs.loading.close()
                this.$emit("closeSidebar");
                this.initValues();
                this.$vs.notify({
                  title: "Ok",
                  text: "Eld updated",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                });
              })
              .catch((x) => {
                // this.$vs.loading.close()
                this.$vs.notify({
                  title: "Error",
                  text: "Serial number not edited",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 40%;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
